'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = LogoOnlyHeader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function LogoOnlyHeader() {
    return _react2['default'].createElement(
        'div',
        { className: 'row l-header l-padded l-padding-b-30 l-padding-t-40' },
        _react2['default'].createElement(
            'div',
            { className: 'small-12 columns logo' },
            _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement('img', { src: require('common/images/logo@2x.png') })
            )
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/headers/logo-only-header.jsx
 ** module id = 1090
 ** module chunks = 0
 **/